




























import Vue, { PropType } from 'vue';
import { IMissingFieldValidation } from '~/utils/user/validateCandidateData';

export default Vue.extend({
    name: 'MissingFields',
    props: {
        missingFieldsData: {
            type: Object as PropType<IMissingFieldValidation>,
            default: {},
            required: true,
        },
    },
    computed: {
        onlyTermsMissing(): boolean {
            return (
                Object.entries(this.missingFieldsData).reduce<boolean>(
                    (acc, [key, value]) => (key === 'terms' ? acc : acc && value),
                    true
                ) && !this.missingFieldsData.terms
            );
        },
        missingFields(): string[] {
            const translation = (key: string): string =>
                this.$t(`vfair.profile.validation.${key}`).toString();

            return Object.entries(this.missingFieldsData).reduce<string[]>(
                (acc, [key, value]) => (!value ? [...acc, translation(key)] : acc),
                []
            );
        },
    },
});
